import { Space } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';
import { Box } from '../../Common/BoxV2';
import { Typography } from '../../DesignSystemV2/Typography';
import { Divider } from '../../Divider/Divider';
import { FilterStore } from '../store/filter.store';
import { useFilterStore } from '../useStore';
import { FilterGroup } from './FilterGroup';
import { SearchInput } from './SearchInput';

const Main = styled.div`
  height: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr;
  display: grid;
  gap: 24px;

  .scroll-content {
    max-height: 800px;
    overflow: auto;
    padding: 0 16px 16px;
  }
`;

const Container = styled.div`
  width: 252px;
  border-radius: 12px;
  border: 1px solid ${colorsV2.black10};
  .title-header {
    padding: 16px 16px 0;
  }

  &.search-box {
    padding: 16px;
  }
`;

export const FilterDesktop = observer(() => {
  const filterStore = useFilterStore();

  if (!filterStore) {
    return null;
  }

  const { search, update, visibleGroups } = filterStore;

  return (
    <Main>
      <Container className="search-box">
        <Typography.Paragraph variant="bold/20" color="black100">
          Tìm kiếm
        </Typography.Paragraph>

        <Box mt="12px" mb="8px">
          <SearchInput
            defaultValue={search}
            onSearch={(value) => {
              update(value);
            }}
            disabled={filterStore.isFilterOnly}
          />
        </Box>
      </Container>
      <Container>
        <Typography.Paragraph className="title-header" variant="bold/20" color="black100">
          Bộ lọc
        </Typography.Paragraph>
        <Box className="scroll-content">
          <Space
            size={16}
            split={<Divider.Line space={0} />}
            style={{ width: '100%' }}
            direction="vertical"
          >
            {visibleGroups.map((group) => (
              <FilterGroup groupId={group.uuid} key={group.uuid} model={FilterStore} />
            ))}
          </Space>
        </Box>
      </Container>
    </Main>
  );
});
